import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { stats } from '../mockData';
import { User } from 'lucide-react';

export const About = () => {
  return (
    <div className="min-h-screen pt-20 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-16 fade-in">
          <h1 className="text-4xl md:text-5xl font-bold text-[#404040] mb-4">
            About Harry & Jacobs
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Your trusted estate agents in Harrow, committed to excellence in property services
          </p>
        </div>

        {/* Company Story */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
              alt="Harry & Jacobs Office"
              className="rounded-lg shadow-xl w-full h-[500px] object-cover"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-[#404040] mb-6">Our Story</h2>
            <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
              <p>
                At Harry & Jacobs, we're here to help you every step of the way. Based in the heart of Harrow, 
                we've built our reputation on delivering results that truly move you forward.
              </p>
              <p>
                With over 15 years of experience in the local property market, we understand what it takes to 
                achieve exceptional outcomes for our clients. Whether you're buying, selling, renting, or managing 
                property, we combine local expertise with a personal touch.
              </p>
              <p>
                Our commitment to excellence has earned us a 97% achievement rate of asking prices and a 92% 
                tenant renewal rate. But beyond the numbers, what sets us apart is our dedication to making your 
                property journey as smooth and stress-free as possible.
              </p>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-gray-50 rounded-2xl p-12 mb-20">
          <h2 className="text-3xl font-bold text-[#404040] mb-12 text-center">
            Our Track Record
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="stat-number mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Director Section */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#404040] mb-4">
              Leadership
            </h2>
          </div>

          <div className="flex justify-center">
            <Card className="border-none shadow-lg max-w-sm w-full">
              <div className="p-8 text-center">
                <div className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-[#FF8C42] to-[#FF6B35] rounded-full flex items-center justify-center">
                  <User className="w-16 h-16 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-[#404040] mb-2">Asad Kanaan</h3>
                <p className="text-[#FF8C42] font-semibold text-lg">Director</p>
              </div>
            </Card>
          </div>
        </div>

        {/* Values Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          <Card className="border-none shadow-lg p-8 text-center card-hover">
            <div className="text-4xl font-bold text-[#FF8C42] mb-4">Exclusive</div>
            <h3 className="text-xl font-bold text-[#404040] mb-3">Premium Service</h3>
            <p className="text-gray-600">
              We consistently achieve 97% of the asking price through expert marketing and negotiation
            </p>
          </Card>

          <Card className="border-none shadow-lg p-8 text-center card-hover">
            <div className="text-4xl font-bold text-[#FF8C42] mb-4">Available</div>
            <h3 className="text-xl font-bold text-[#404040] mb-3">Always Here</h3>
            <p className="text-gray-600">
              We work for you! Our team is always available to answer questions and provide support
            </p>
          </Card>

          <Card className="border-none shadow-lg p-8 text-center card-hover">
            <div className="text-4xl font-bold text-[#FF8C42] mb-4">Flexible</div>
            <h3 className="text-xl font-bold text-[#404040] mb-3">Tailored Solutions</h3>
            <p className="text-gray-600">
              92% of tenants renew their tenancies, reflecting our flexible and professional approach
            </p>
          </Card>
        </div>

        {/* Location Section */}
        <div className="bg-[#404040] rounded-2xl p-12 text-white text-center">
          <h2 className="text-3xl font-bold mb-6">Visit Our Office</h2>
          <p className="text-xl mb-4">25 Masons Avenue, Harrow HA3 5AH, UK</p>
          <p className="text-lg text-gray-300 mb-8">
            Located in the heart of Harrow, we're perfectly positioned to serve the local community
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left max-w-3xl mx-auto">
            <div>
              <p className="font-semibold text-[#FF8C42] mb-2">Opening Hours</p>
              <p className="text-sm">Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p className="text-sm">Saturday: 10:00 AM - 4:00 PM</p>
              <p className="text-sm">Sunday: Closed</p>
            </div>
            <div>
              <p className="font-semibold text-[#FF8C42] mb-2">Phone</p>
              <p className="text-sm">020 8189 8889</p>
            </div>
            <div>
              <p className="font-semibold text-[#FF8C42] mb-2">Email</p>
              <p className="text-sm">info@harryandjacobs.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
